module.exports = __webpack_public_path__ + "img/ydy2@3x.95294726.png";